import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'

const SubcategoriesCreateForm = () => {
    const [errText, setErrText] = useState()
    const [imgSrc, setImgSrc] = useState()
    const [itemName, setItemName] = useState()
    const [itemCategory, setItemCategory] = useState()
    const [itemSubcategory, setItemSubcategory] = useState()
    const [itemPrice, setItemPrice] = useState()
  
    return (
      <Form onSubmit={(e) => console.log(e)} className='p-4 w-100 m-auto'>
        <Form.Group className='d-flex flex-column mt-4'>
          <Form.Label>Choose a Category</Form.Label>
          <div>
            {["0","1","2","3","4","5","6"].map(x => <Form.Check
              key={x}
              inline
              label={x}
              name="group1"
              type="radio"
              id={`inline-${x}`}
              />)}
          </div>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formNewCategory">
          <Form.Label>New Category Name</Form.Label>
          <Form.Control className='py-2 px-3 fs-5' onChange={e => setImgSrc(e.target.value)} required type="text" placeholder="Example Category" />
        </Form.Group>
        <p className='text-danger' id="sign-in-error-text">{errText}</p>
        <Button disabled={false} className='py-2 w-100 px-5 mt-3 fs-4' variant="outline-dark" type="submit">
          Submit
        </Button>
      </Form>
    )
  
}

export default SubcategoriesCreateForm